export const appVideoPlayIcon = {
    data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 14"><path d="M11 7L0 14V0l11 7z" fill="var(--icon-color, currentColor)"/></svg>`,
    name: 'video-play'
};